module.exports = __webpack_public_path__ + "img/skyline.2154b452.png";